import type { ComponentProps, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { SelectButton } from '~modules/media-library/view/SelectButton';

// export const FilterButton = forwardRef<
//   ComponentRef<typeof Button>,
//   Omit<ComponentProps<typeof Button>, 'className' | 'variant'> & { count?: number }
// >(function FilterButton({ children, count = 0, ...ButtonProps }, ref) {
//   return (
//     <Button className="ml--filter-button" {...ButtonProps} ref={ref}>
//       {children}
//       {!ButtonProps.disabled && count > 0 && (
//         <span className="w-4 h-4 rounded-full bg-black text-white text-xs flex items-center justify-center ml-2">
//           {Math.min(count, 99)}
//         </span>
//       )}
//       {!ButtonProps.disabled && <CaretDownIcon className="w-4 h-4 -mr-2 ml-1" />}
//     </Button>
//   );
// });

export const FilterButton = forwardRef<
  ComponentRef<typeof SelectButton>,
  ComponentProps<typeof SelectButton> & { count?: number }
>(function FilterButton({ children, count = 0, className = '', ...ButtonProps }, ref) {
  return (
    <SelectButton className={`ml--filter-button ${className}`} {...ButtonProps} ref={ref}>
      {children}
      {!ButtonProps.disabled && count > 0 && (
        <span className="w-4 h-4 rounded-full bg-black text-white text-xs flex items-center justify-center ml-2">
          {Math.min(count, 99)}
        </span>
      )}
    </SelectButton>
  );
});
